import React, { Fragment, useState } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
  Collapse,
} from "reactstrap";
export default function LeadInfo({ data }) {
  const [custom2, setCustom2] = useState(false);

  return (
    <Fragment>
      <TransitionGroup>
        <CSSTransition
          component="div"
          classNames="TabsAnimation"
          appear={true}
          timeout={0}
          enter={false}
          exit={false}
        >
          <div>
            <Row>
              {/* {data?.lead_info?.inheritance && (
                <Col md="12">
                  <Card className="main-card mb-2">
                    <CardBody>
                      <CardTitle>
                        <Row>
                          <Col xs="10">
                            <legend>INHERITANCE</legend>
                          </Col>
                          <Col xs="2">
                            <Button
                              className="m-0 p-0"
                              color="link"
                              onClick={() => setCustom3(!custom3)}
                            >
                              {custom3 === false ? "Expand" : "Collapse"}
                            </Button>
                          </Col>
                        </Row>
                      </CardTitle>

                      <Collapse isOpen={custom3}>
                        <Row>
                          <Col md="12">
                            <Card className="main-card mb-1">
                              <CardBody>
                                <CardTitle></CardTitle>

                                <Row className="g-0">
                                  <Col md="4">
                                    <div className="card widget-chart p-0">
                                      <div className="widget-numbers">
                                        Inheritance
                                      </div>
                                      <div className="widget-subheading">
                                        Lead Type
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md="4">
                                    <div className="card widget-chart p-0">
                                      <div className="widget-numbers">
                                        {data?.lead_info?.inheritance
                                          ?.inheritance_id || "-"}
                                      </div>
                                      <div className="widget-subheading">
                                        Case ID
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md="4">
                                    <div className="card  widget-chart p-0">
                                      <div className="widget-numbers">
                                        {data?.lead_info?.inheritance
                                          ?.p_month || "-"}{" "}
                                        /{" "}
                                        {data?.lead_info?.inheritance?.p_day ||
                                          "-"}{" "}
                                        /{" "}
                                        {data?.lead_info?.inheritance?.p_year ||
                                          "-"}
                                      </div>
                                      <div className="widget-subheading">
                                        Lead Date
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <Card className="main-card mb-1">
                              <CardBody>
                                <CardTitle>Owner</CardTitle>

                                <Row>
                                  {data?.lead_info?.inheritance?.people &&
                                    Object.keys(
                                      data?.lead_info?.inheritance?.people
                                    ).map((key) => (
                                      <Fragment key={key}>
                                        {data?.lead_info?.inheritance?.people[
                                          key
                                        ]?.title.toLowerCase() ==
                                          "decedent" && (
                                          <>
                                            <Col
                                              md="12"
                                              className="mb-2"
                                              key={key}
                                            >
                                              <Card className="main-card">
                                                <CardBody>
                                                  <CardTitle></CardTitle>

                                                  <Row>
                                                    <Col
                                                      md="5"
                                                      className="text-center"
                                                    >
                                                      <Row className="g-0">
                                                        <Col md="12">
                                                          <h4 className="text-primary m-0 text-center">
                                                            Owner
                                                          </h4>
                                                        </Col>
                                                        <Col md="12">
                                                          <h3
                                                            style={{
                                                              color: "#003333",
                                                            }}
                                                          >
                                                            {data?.lead_info
                                                              ?.inheritance
                                                              ?.people[key]
                                                              ?.full_name ||
                                                              " "}{" "}
                                                          </h3>
                                                        </Col>
                                                        <Col md="12">
                                                          <p>
                                                            {data?.lead_info
                                                              ?.inheritance
                                                              ?.people[key]
                                                              ?.addresses[0]
                                                              ?.address1 || ""}
                                                            <br />{" "}
                                                            {
                                                              data?.lead_info
                                                                ?.inheritance
                                                                ?.people[key]
                                                                ?.addresses[0]
                                                                ?.city
                                                            }
                                                            ,{" "}
                                                            {
                                                              data?.lead_info
                                                                ?.inheritance
                                                                ?.people[key]
                                                                ?.addresses[0]
                                                                ?.state
                                                            }{" "}
                                                            {
                                                              data?.lead_info
                                                                ?.inheritance
                                                                ?.people[key]
                                                                ?.addresses[0]
                                                                ?.zip
                                                            }
                                                          </p>
                                                        </Col>
                                                        <Col md="6">
                                                          <p>
                                                            <b>AGE:</b>{" "}
                                                            {data?.lead_info
                                                              ?.inheritance
                                                              ?.people[key]
                                                              ?.age || "-"}
                                                          </p>
                                                        </Col>
                                                        <Col md="6">
                                                          {" "}
                                                          <p>
                                                            <b>Gender:</b>{" "}
                                                            {data?.lead_info
                                                              ?.inheritance
                                                              ?.people[key]
                                                              ?.gender || "-"}
                                                          </p>
                                                        </Col>
                                                        <Col md="12">
                                                          <p>
                                                            <b>Birth:</b>{" "}
                                                            {data?.lead_info
                                                              ?.inheritance
                                                              ?.people[key]
                                                              ?.dob || "-"}
                                                          </p>
                                                          <p>
                                                            <b>Death:</b>{" "}
                                                            {data?.lead_info
                                                              ?.inheritance
                                                              ?.people[key]
                                                              ?.dod || "-"}
                                                          </p>
                                                        </Col>
                                                      </Row>
                                                    </Col>
                                                    <Col md="7">
                                                      <Row>
                                                        <Col xs="10" md="9">
                                                          <h5 className="fw-bold">
                                                            Phone Numbers
                                                          </h5>{" "}
                                                        </Col>
                                                        <Col
                                                          xs="2"
                                                          md="3"
                                                        ></Col>
                                                      </Row>
                                                      <Row className="g-0">
                                                        {data?.lead_info?.inheritance?.people[
                                                          key
                                                        ]?.phones?.map(
                                                          (ph, k) => (
                                                            <Col
                                                              xs="6"
                                                              className="mb-1"
                                                              key={k}
                                                            >
                                                              {ph.phone}
                                                              <Button
                                                                className="border-0 btn-transition"
                                                                outline
                                                                color="success"
                                                                title=" Call"
                                                                onClick={() =>
                                                                  (window.location.href = `tel:${ph?.phone}`)
                                                                }
                                                              >
                                                                <FontAwesomeIcon
                                                                  icon={faPhone}
                                                                  size="1x"
                                                                />
                                                              </Button>
                                                            </Col>
                                                          )
                                                        )}
                                                      </Row>

                                                      <Row>
                                                        <Col xs="10">
                                                          <h5 className="fw-bold mt-3">
                                                            Emails{" "}
                                                          </h5>
                                                        </Col>
                                                        <Col xs="2"></Col>
                                                      </Row>

                                                      {data?.lead_info?.inheritance?.people[
                                                        key
                                                      ]?.emails?.map((e, k) => (
                                                        <Row
                                                          className="g-0"
                                                          key={k}
                                                        >
                                                          <Col
                                                            xs="10"
                                                            className="mb-1"
                                                          >
                                                            {e.email}
                                                          </Col>
                                                          <Col xs="2">
                                                            <Button
                                                              className="border-0 btn-transition"
                                                              outline
                                                              color="info"
                                                              title=" Mail"
                                                              onClick={() =>
                                                                window.open(
                                                                  `mailto:${e.email}`
                                                                )
                                                              }
                                                            >
                                                              <FontAwesomeIcon
                                                                icon={
                                                                  faEnvelope
                                                                }
                                                                size="1x"
                                                              />
                                                            </Button>
                                                          </Col>
                                                        </Row>
                                                      ))}
                                                    </Col>
                                                  </Row>
                                                </CardBody>
                                              </Card>
                                            </Col>
                                          </>
                                        )}
                                      </Fragment>
                                    ))}
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="12">
                            <Card className="main-card mb-1">
                              <CardBody>
                                <CardTitle>Relatives</CardTitle>

                                <Row>
                                  {data?.lead_info?.inheritance?.people &&
                                    Object.keys(
                                      data?.lead_info?.inheritance?.people
                                    ).map((key) => (
                                      <Fragment key={key}>
                                        {data?.lead_info?.inheritance?.people[
                                          key
                                        ]?.title.toLowerCase() ==
                                          "relatives" && (
                                          <>
                                            <Col
                                              md="12"
                                              className="mb-2"
                                              key={key}
                                            >
                                              <Card className="main-card">
                                                <CardBody>
                                                  <CardTitle></CardTitle>

                                                  <Row>
                                                    <Col
                                                      md="5"
                                                      className="text-center"
                                                    >
                                                      <Row className="g-0">
                                                        <Col md="12">
                                                          <h4 className="text-primary m-0 text-center">
                                                            Relative
                                                          </h4>
                                                        </Col>
                                                        <Col md="12">
                                                          <h3
                                                            style={{
                                                              color: "#003333",
                                                            }}
                                                          >
                                                            {data?.lead_info
                                                              ?.inheritance
                                                              ?.people[key]
                                                              ?.full_name ||
                                                              " "}{" "}
                                                          </h3>
                                                        </Col>
                                                        <Col md="12">
                                                          <p>
                                                            {data?.lead_info
                                                              ?.inheritance
                                                              ?.people[key]
                                                              ?.addresses[0]
                                                              ?.address1 || ""}
                                                            <br />{" "}
                                                            {
                                                              data?.lead_info
                                                                ?.inheritance
                                                                ?.people[key]
                                                                ?.addresses[0]
                                                                ?.city
                                                            }
                                                            ,{" "}
                                                            {
                                                              data?.lead_info
                                                                ?.inheritance
                                                                ?.people[key]
                                                                ?.addresses[0]
                                                                ?.state
                                                            }{" "}
                                                            {
                                                              data?.lead_info
                                                                ?.inheritance
                                                                ?.people[key]
                                                                ?.addresses[0]
                                                                ?.zip
                                                            }
                                                          </p>
                                                        </Col>
                                                        <Col md="6">
                                                          <p>
                                                            <b>AGE:</b>{" "}
                                                            {data?.lead_info
                                                              ?.inheritance
                                                              ?.people[key]
                                                              ?.age || "-"}
                                                          </p>
                                                        </Col>
                                                        <Col md="6">
                                                          {" "}
                                                          <p>
                                                            <b>Gender:</b>{" "}
                                                            {data?.lead_info
                                                              ?.inheritance
                                                              ?.people[key]
                                                              ?.gender || "-"}
                                                          </p>
                                                        </Col>
                                                      </Row>
                                                    </Col>
                                                    <Col md="7">
                                                      <Row>
                                                        <Col xs="10" md="9">
                                                          <h5 className="fw-bold">
                                                            Phone Numbers
                                                          </h5>{" "}
                                                        </Col>
                                                        <Col
                                                          xs="2"
                                                          md="3"
                                                        ></Col>
                                                      </Row>
                                                      <Row className="g-0">
                                                        {data?.lead_info
                                                          ?.inheritance?.people[
                                                          key
                                                        ]?.phones &&
                                                          data?.lead_info?.inheritance?.people[
                                                            key
                                                          ]?.phones?.map(
                                                            (ph, k) => (
                                                              <Col
                                                                xs="6"
                                                                className="mb-1"
                                                                key={k}
                                                              >
                                                                {ph.phone}
                                                                <Button
                                                                  className="border-0 btn-transition"
                                                                  outline
                                                                  color="success"
                                                                  title=" Call"
                                                                  onClick={() =>
                                                                    (window.location.href = `tel:${ph?.phone}`)
                                                                  }
                                                                >
                                                                  <FontAwesomeIcon
                                                                    icon={
                                                                      faPhone
                                                                    }
                                                                    size="1x"
                                                                  />
                                                                </Button>
                                                              </Col>
                                                            )
                                                          )}
                                                      </Row>

                                                      <Row>
                                                        <Col xs="10">
                                                          <h5 className="fw-bold mt-3">
                                                            Emails{" "}
                                                          </h5>
                                                        </Col>
                                                        <Col xs="2"></Col>
                                                      </Row>

                                                      {data?.lead_info
                                                        ?.inheritance?.people[
                                                        key
                                                      ]?.emails &&
                                                        data?.lead_info?.inheritance?.people[
                                                          key
                                                        ]?.emails?.map(
                                                          (e, k) => (
                                                            <Row
                                                              className="g-0"
                                                              key={k}
                                                            >
                                                              <Col
                                                                xs="10"
                                                                className="mb-1"
                                                              >
                                                                {e.email}
                                                              </Col>
                                                              <Col xs="2">
                                                                <Button
                                                                  className="border-0 btn-transition"
                                                                  outline
                                                                  color="info"
                                                                  title=" Mail"
                                                                  onClick={() =>
                                                                    window.open(
                                                                      `mailto:${e.email}`
                                                                    )
                                                                  }
                                                                >
                                                                  <FontAwesomeIcon
                                                                    icon={
                                                                      faEnvelope
                                                                    }
                                                                    size="1x"
                                                                  />
                                                                </Button>
                                                              </Col>
                                                            </Row>
                                                          )
                                                        )}
                                                    </Col>
                                                  </Row>
                                                </CardBody>
                                              </Card>
                                            </Col>
                                          </>
                                        )}
                                      </Fragment>
                                    ))}
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </Collapse>
                    </CardBody>
                  </Card>
                </Col>
              )}

              {data?.lead_info?.preforeclosure && (
                <Col md="12">
                  <Card className="main-card mb-2">
                    <CardBody>
                      <CardTitle>
                        <Row>
                          <Col xs="10">
                            <legend>Preforeclosure</legend>
                          </Col>
                          <Col xs="2">
                            <Button
                              className="m-0 p-0"
                              color="link"
                              onClick={() => setCustom3(!custom3)}
                            >
                              {custom3 === false ? "Expand" : "Collapse"}
                            </Button>
                          </Col>
                        </Row>
                      </CardTitle>

                      <Collapse isOpen={custom3}>
                        <Row>
                          <Col md="12">
                            <Card className="main-card mb-1">
                              <CardBody>
                                <CardTitle></CardTitle>

                                <Row className="g-0">
                                  <Col md="4">
                                    <div className="card widget-chart p-0">
                                      <div className="widget-numbers">
                                        Preforeclosure
                                      </div>
                                      <div className="widget-subheading">
                                        Lead Type
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md="4">
                                    <div className="card widget-chart p-0">
                                      <div className="widget-numbers">
                                        {data?.lead_info?.preforeclosure
                                          ?.preforeclosure_id || "-"}
                                      </div>
                                      <div className="widget-subheading">
                                        Case ID
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md="4">
                                    <div className="card  widget-chart p-0">
                                      <div className="widget-numbers">
                                        {data?.lead_info?.preforeclosure
                                          ?.p_month || "-"}{" "}
                                        /{" "}
                                        {data?.lead_info?.preforeclosure
                                          ?.p_day || "-"}{" "}
                                        /{" "}
                                        {data?.lead_info?.preforeclosure
                                          ?.p_year || "-"}
                                      </div>
                                      <div className="widget-subheading">
                                        Lead Date
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <Card className="main-card mb-1">
                              <CardBody>
                                <CardTitle></CardTitle>

                                <Row>
                                  <Col md="5" className="text-center">
                                    <Row className="g-0">
                                      <Col md="12">
                                        <h4 className="text-primary m-0 text-center">
                                          Owner
                                        </h4>
                                      </Col>
                                      <Col md="12">
                                        <h3 style={{ color: "#003333" }}>
                                          {data?.lead_info?.preforeclosure
                                            ?.first_name || " "}{" "}
                                          {data?.lead_info?.preforeclosure
                                            ?.middle_name || " "}{" "}
                                          {data?.lead_info?.preforeclosure
                                            ?.last_name || " "}{" "}
                                        </h3>
                                      </Col>
                                      <Col md="12">
                                        <p>
                                          {data?.lead_info?.preforeclosure
                                            ?.mailing_address1 || ""}
                                          <br />{" "}
                                          {
                                            data?.lead_info?.preforeclosure
                                              ?.mailing_city
                                          }
                                          ,{" "}
                                          {
                                            data?.lead_info?.preforeclosure
                                              ?.mailing_state
                                          }{" "}
                                          {
                                            data?.lead_info?.preforeclosure
                                              ?.mailing_zip
                                          }
                                        </p>
                                      </Col>
                                      <Col md="6">
                                        <p>
                                          <b>AGE:</b>{" "}
                                          {data?.lead_info?.preforeclosure
                                            ?.age || "-"}
                                        </p>
                                      </Col>
                                      <Col md="6">
                                        {" "}
                                        <p>
                                          <b>Gender:</b>{" "}
                                          {data?.lead_info?.preforeclosure
                                            ?.gender || "-"}
                                        </p>
                                      </Col>
                                      <Col md="12">
                                        <p>
                                          <b>Birth:</b>{" "}
                                          {data?.lead_info?.preforeclosure
                                            ?.dob || "-"}
                                        </p>
                                        <p>
                                          <b>Death:</b>{" "}
                                          {data?.lead_info?.preforeclosure
                                            ?.dod || "-"}
                                        </p>
                                      </Col>
                                    </Row>
                                  </Col>
                                  <Col md="7">
                                    <Row>
                                      <Col xs="10" md="9">
                                        <h5 className="fw-bold">
                                          Phone Numbers
                                        </h5>{" "}
                                      </Col>
                                      <Col xs="2" md="3"></Col>
                                    </Row>
                                    <Row className="g-0">
                                      {data?.lead_info?.preforeclosure?.phones?.map(
                                        (ph, k) => (
                                          <Col xs="6" className="mb-1" key={k}>
                                            {ph.phone}
                                            <Button
                                              className="border-0 btn-transition"
                                              outline
                                              color="success"
                                              title=" Call"
                                              onClick={() =>
                                                (window.location.href = `tel:${ph?.phone}`)
                                              }
                                            >
                                              <FontAwesomeIcon
                                                icon={faPhone}
                                                size="1x"
                                              />
                                            </Button>
                                          </Col>
                                        )
                                      )}
                                    </Row>

                                    <Row>
                                      <Col xs="10">
                                        <h5 className="fw-bold mt-3">
                                          Emails{" "}
                                        </h5>
                                      </Col>
                                      <Col xs="2"></Col>
                                    </Row>

                                    {data?.lead_info?.preforeclosure?.emails?.map(
                                      (e, k) => (
                                        <Row className="g-0" key={k}>
                                          <Col xs="10" className="mb-1">
                                            {e}
                                          </Col>
                                          <Col xs="2">
                                            <Button
                                              className="border-0 btn-transition"
                                              outline
                                              color="info"
                                              title=" Mail"
                                              onClick={() =>
                                                window.open(`mailto:${e}`)
                                              }
                                            >
                                              <FontAwesomeIcon
                                                icon={faEnvelope}
                                                size="1x"
                                              />
                                            </Button>
                                          </Col>
                                        </Row>
                                      )
                                    )}
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="12">
                            <Card className="main-card mb-1">
                              <CardBody>
                                <CardTitle>Relatives</CardTitle>
                                <Row>
                                  {data?.lead_info?.preforeclosure?.relatives?.map(
                                    (v, k) => (
                                      <Col md="12" className="mb-2" key={k}>
                                        <Card className="main-card">
                                          <CardBody>
                                            <CardTitle></CardTitle>

                                            <Row>
                                              <Col
                                                md="5"
                                                className="text-center"
                                              >
                                                <Row className="g-0">
                                                  <Col md="12">
                                                    <h4 className="text-primary m-0 text-center">
                                                      Relative
                                                    </h4>
                                                  </Col>
                                                  <Col md=" 12">
                                                    {" "}
                                                    <h3>
                                                      {v.first_name}{" "}
                                                      {v.middle_name}{" "}
                                                      {v.last_name}{" "}
                                                    </h3>
                                                  </Col>
                                                  <Col md=" 12">
                                                    <Row className="g-0 mt-2 mb-2">
                                                      {v.addresses?.map(
                                                        (address, k) => (
                                                          <Col md="12" key={k}>
                                                            {address.address1},{" "}
                                                            {address.city},{" "}
                                                            {address.state}{" "}
                                                            {address.zip}
                                                          </Col>
                                                        )
                                                      )}
                                                    </Row>
                                                  </Col>
                                                  <Col md="6">
                                                    <p>
                                                      <b>AGE:</b> {v.age || "-"}
                                                    </p>
                                                  </Col>
                                                  <Col md="6">
                                                    <p>
                                                      <b>Gender:</b>{" "}
                                                      {v.gender || "-"}
                                                    </p>
                                                  </Col>
                                                </Row>
                                              </Col>
                                              <Col md="7">
                                                <Row>
                                                  <Col xs="10" md="9">
                                                    <h5 className="fw-bold">
                                                      Phone Numbers
                                                    </h5>{" "}
                                                  </Col>
                                                  <Col xs="2" md="3"></Col>
                                                </Row>
                                                <Row className="g-0">
                                                  {v?.phones?.map((ph, k) => (
                                                    <Col
                                                      xs="6"
                                                      className="mb-1"
                                                      key={k}
                                                    >
                                                      {ph.phone}
                                                      <Button
                                                        className="border-0 btn-transition"
                                                        outline
                                                        color="success"
                                                        onClick={() =>
                                                          (window.location.href = `tel:${ph?.phone}`)
                                                        }
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={faPhone}
                                                          size="1x"
                                                        />
                                                      </Button>
                                                    </Col>
                                                  ))}
                                                </Row>

                                                <Row>
                                                  <Col xs="10">
                                                    <h5 className="fw-bold mt-3">
                                                      Emails{" "}
                                                    </h5>
                                                  </Col>
                                                  <Col xs="2"></Col>
                                                </Row>

                                                {v?.emails?.map((e, k) => (
                                                  <Row className="g-0" key={k}>
                                                    <Col
                                                      xs="10"
                                                      className="mb-1"
                                                    >
                                                      {e}
                                                    </Col>
                                                    <Col xs="2">
                                                      <Button
                                                        className="border-0 btn-transition"
                                                        outline
                                                        color="info"
                                                        title=" Mail"
                                                        onClick={() =>
                                                          window.open(
                                                            `mailto:${e}`
                                                          )
                                                        }
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={faEnvelope}
                                                          size="1x"
                                                        />
                                                      </Button>
                                                    </Col>
                                                  </Row>
                                                ))}
                                              </Col>
                                            </Row>
                                          </CardBody>
                                        </Card>
                                      </Col>
                                    )
                                  )}
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </Collapse>
                    </CardBody>
                  </Card>
                </Col>
              )}

              {data?.lead_info?.probate && (
                <Col md="12">
                  <Card className="main-card mb-2">
                    <CardBody>
                      <CardTitle>
                        <Row>
                          <Col xs="10">
                            <legend>PROBATE</legend>
                          </Col>
                          <Col xs="2">
                            <Button
                              className="m-0 p-0"
                              color="link"
                              onClick={() => setCustom2(!custom2)}
                            >
                              {custom2 === false ? "Expand" : "Collapse"}
                            </Button>
                          </Col>
                        </Row>
                      </CardTitle>

                      <Collapse isOpen={custom2}>
                        <Row>
                          <Col md="12">
                            <Card className="main-card mb-1">
                              <CardBody>
                                <Row className="g-1">
                                  <Col md="4">
                                    <div className="card widget-chart p-0">
                                      <div className="widget-numbers">
                                        Probate
                                      </div>
                                      <div className="widget-subheading">
                                        Lead Type
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md="4">
                                    <div className="card widget-chart p-0">
                                      <div className="widget-numbers">
                                        {data?.lead_info?.probate?.probate_id ||
                                          "-"}
                                      </div>
                                      <div className="widget-subheading">
                                        Case ID
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md="4">
                                    <div className="card  widget-chart p-0">
                                      <div className="widget-numbers">
                                        {data?.lead_info?.probate?.p_month ||
                                          "-"}{" "}
                                        /{" "}
                                        {data?.lead_info?.probate?.p_day || "-"}{" "}
                                        /{" "}
                                        {data?.lead_info?.probate?.p_year ||
                                          "-"}
                                      </div>
                                      <div className="widget-subheading">
                                        Lead Date
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <Card className="main-card mb-1">
                              <CardBody>
                                <CardTitle></CardTitle>

                                <Row>
                                  <Col md="5" className="text-center">
                                    <Row className="g-0">
                                      <Col md="12">
                                        <h4 className="text-primary m-0 text-center">
                                          Deceased
                                        </h4>
                                      </Col>
                                      <Col md="12">
                                        <h3 style={{ color: "#003333" }}>
                                          {data?.lead_info?.probate
                                            ?.first_name || " "}{" "}
                                          {data?.lead_info?.probate
                                            ?.middle_name || " "}{" "}
                                          {data?.lead_info?.probate
                                            ?.last_name || " "}{" "}
                                        </h3>
                                      </Col>
                                      <Col md="12">
                                        <p>
                                          {data?.lead_info?.probate
                                            ?.mailing_address1 || ""}
                                          <br />{" "}
                                          {
                                            data?.lead_info?.probate
                                              ?.mailing_city
                                          }
                                          ,{" "}
                                          {
                                            data?.lead_info?.probate
                                              ?.mailing_state
                                          }{" "}
                                          {
                                            data?.lead_info?.probate
                                              ?.mailing_zip
                                          }
                                        </p>
                                      </Col>
                                      <Col md="6">
                                        <p>
                                          <b>AGE:</b>{" "}
                                          {data?.lead_info?.probate?.age || "-"}
                                        </p>
                                      </Col>
                                      <Col md="6">
                                        {" "}
                                        <p>
                                          <b>Gender:</b>{" "}
                                          {data?.lead_info?.probate?.gender ||
                                            "-"}
                                        </p>
                                      </Col>
                                      <Col md="12">
                                        <p>
                                          <b>Birth:</b>{" "}
                                          {data?.lead_info?.probate?.dob || "-"}
                                        </p>
                                        <p>
                                          <b>Death:</b>{" "}
                                          {data?.lead_info?.probate?.dod || "-"}
                                        </p>
                                      </Col>
                                    </Row>
                                  </Col>
                                  <Col md="7">
                                    <Row>
                                      <Col xs="10" md="9">
                                        <h5 className="fw-bold">
                                          Phone Numbers
                                        </h5>{" "}
                                      </Col>
                                      <Col xs="2" md="3"></Col>
                                    </Row>
                                    <Row className="g-0">
                                      {data?.lead_info?.probate?.phones?.map(
                                        (ph, k) => (
                                          <Col xs="6" className="mb-1" key={k}>
                                            {ph.phone}
                                            <Button
                                              className="border-0 btn-transition"
                                              outline
                                              color="success"
                                              onClick={() =>
                                                (window.location.href = `tel:${ph?.phone}`)
                                              }
                                            >
                                              <FontAwesomeIcon
                                                icon={faPhone}
                                                size="1x"
                                              />
                                            </Button>
                                          </Col>
                                        )
                                      )}
                                    </Row>

                                    <Row>
                                      <Col xs="10">
                                        <h5 className="fw-bold mt-3">
                                          Emails{" "}
                                        </h5>
                                      </Col>
                                      <Col xs="2"></Col>
                                    </Row>

                                    {data?.lead_info?.probate?.emails?.map(
                                      (e, k) => (
                                        <Row className="g-0" key={k}>
                                          <Col xs="10" className="mb-1">
                                            {e}
                                          </Col>
                                          <Col xs="2">
                                            <Button
                                              className="border-0 btn-transition"
                                              outline
                                              color="info"
                                              title=" Mail"
                                              onClick={() =>
                                                window.open(`mailto:${e}`)
                                              }
                                            >
                                              <FontAwesomeIcon
                                                icon={faEnvelope}
                                                size="1x"
                                              />
                                            </Button>
                                          </Col>
                                        </Row>
                                      )
                                    )}
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="12">
                            <Card className="main-card mb-1">
                              <CardBody>
                                <CardTitle>Relatives</CardTitle>
                                <Row>
                                  {data?.lead_info?.probate?.relatives?.map(
                                    (v, k) => (
                                      <Col md="12" className="mb-2" key={k}>
                                        <Card className="main-card">
                                          <CardBody>
                                            <CardTitle></CardTitle>

                                            <Row>
                                              <Col
                                                md="5"
                                                className="text-center"
                                              >
                                                <Row className="g-0">
                                                  <Col md="12">
                                                    <h4 className="text-primary m-0 text-center">
                                                      Relative
                                                    </h4>
                                                  </Col>
                                                  <Col md=" 12">
                                                    {" "}
                                                    <h3>
                                                      {v.first_name}{" "}
                                                      {v.middle_name}{" "}
                                                      {v.last_name}{" "}
                                                    </h3>
                                                  </Col>
                                                  <Col md=" 12">
                                                    <Row className="g-0">
                                                      {v.addresses?.map(
                                                        (address, k) => (
                                                          <Col md="12" key={k}>
                                                            <b>ADDRESS:</b>{" "}
                                                            {address.address1},{" "}
                                                            {address.city},{" "}
                                                            {address.state}{" "}
                                                            {address.zip}
                                                          </Col>
                                                        )
                                                      )}
                                                    </Row>
                                                  </Col>
                                                  <Col md="6">
                                                    <p>
                                                      <b>AGE:</b> {v.age || "-"}
                                                    </p>
                                                  </Col>
                                                  <Col md="6">
                                                    <p>
                                                      <b>Gender:</b>{" "}
                                                      {v.gender || "-"}
                                                    </p>
                                                  </Col>
                                                </Row>
                                              </Col>
                                              <Col md="7">
                                                <Row>
                                                  <Col xs="10" md="9">
                                                    <h5 className="fw-bold">
                                                      Phone Numbers
                                                    </h5>{" "}
                                                  </Col>
                                                  <Col xs="2" md="3"></Col>
                                                </Row>
                                                <Row className="g-0">
                                                  {v?.phones?.map((ph, k) => (
                                                    <Col
                                                      xs="12"
                                                      className="mb-1"
                                                      key={k}
                                                    >
                                                      {ph.phone}
                                                      <Button
                                                        className="border-0 btn-transition"
                                                        outline
                                                        color="success"
                                                        onClick={() =>
                                                          (window.location.href = `tel:${ph?.phone}`)
                                                        }
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={faPhone}
                                                          size="1x"
                                                        />
                                                      </Button>
                                                    </Col>
                                                  ))}
                                                </Row>

                                                <Row>
                                                  <Col xs="10">
                                                    <h5 className="fw-bold mt-3">
                                                      Emails{" "}
                                                    </h5>
                                                  </Col>
                                                  <Col xs="2"></Col>
                                                </Row>

                                                {v?.emails?.map((e, k) => (
                                                  <Row className="g-0">
                                                    <Col
                                                      xs="10"
                                                      className="mb-1"
                                                      key={k}
                                                    >
                                                      {e}
                                                    </Col>
                                                    <Col xs="2">
                                                      <Button
                                                        className="border-0 btn-transition"
                                                        outline
                                                        color="info"
                                                        title=" Mail"
                                                        onClick={() =>
                                                          window.open(
                                                            `mailto:${e}`
                                                          )
                                                        }
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={faEnvelope}
                                                          size="1x"
                                                        />
                                                      </Button>
                                                    </Col>
                                                  </Row>
                                                ))}
                                              </Col>
                                            </Row>
                                          </CardBody>
                                        </Card>
                                      </Col>
                                    )
                                  )}
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </Collapse>
                    </CardBody>
                  </Card>
                </Col>
              )} */}
              {data?.lead_info?.frst && (
                <Col md="12">
                  <Card className="main-card mb-2">
                    <CardBody>
                      <CardTitle>
                        <Row>
                          <Col xs="10">
                            <legend>FirstUp</legend>
                          </Col>
                          <Col xs="2">
                            <Button
                              className="m-0 p-0"
                              color="link"
                              onClick={() => setCustom2(!custom2)}
                            >
                              {custom2 === false ? "Expand" : "Collapse"}
                            </Button>
                          </Col>
                        </Row>
                      </CardTitle>

                      <Collapse isOpen={custom2}>
                        <Row>
                          <Col md="12">
                            <Card className="main-card mb-1">
                              <CardBody>
                                <Row className="g-1">
                                  <Col md="4">
                                    <div className="card widget-chart p-0">
                                      <div className="widget-numbers">
                                        FirstUp
                                      </div>
                                      <div className="widget-subheading">
                                        Lead Type
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md="4">
                                    <div className="card widget-chart p-0">
                                      <div className="widget-numbers">
                                        {data?.lead_info?.frst?.probate_id ||
                                          "-"}
                                      </div>
                                      <div className="widget-subheading">
                                        Case ID
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md="4">
                                    <div className="card  widget-chart p-0">
                                      <div className="widget-numbers">
                                        {data?.lead_info?.frst?.p_month ||
                                          "-"}{" "}
                                        /{" "}
                                        {data?.lead_info?.frst?.p_day || "-"}{" "}
                                        /{" "}
                                        {data?.lead_info?.frst?.p_year ||
                                          "-"}
                                      </div>
                                      <div className="widget-subheading">
                                        Lead Date
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            {data?.lead_info?.frst?.people &&
                              Object.keys(data?.lead_info?.frst?.people)
                                .filter(
                                  (key) =>
                                    data?.lead_info?.frst?.people[key]
                                      ?.title !== "Relatives"
                                )
                                .map((key, index) => {
                                  const person =
                                    data?.lead_info?.frst?.people[key];
                                  return (
                                    <Card key={index} className="main-card mb-1">
                                      <CardBody>
                                        <CardTitle></CardTitle>

                                        <Row>
                                          <Col md="5" className="text-center">
                                            <Row className="g-0">
                                              <Col md="12">
                                                <h4 className="text-primary m-0 text-center">
                                                  {person?.title}
                                                </h4>
                                              </Col>
                                              <Col md="12">
                                                <h3
                                                  style={{ color: "#003333" }}
                                                >
                                                  {person?.full_name || " "}{" "}
                                                </h3>
                                              </Col>
                                              <Col md="12">
                                                {Object.keys(
                                                  person?.addresses
                                                ).map((k, index) => {
                                                  const address =
                                                    person?.addresses[key];
                                                  return (
                                                    <p key={index}>
                                                      {address?.address1 || ""}
                                                      <br /> {address?.city},{" "}
                                                      {address?.state}{" "}
                                                      {address?.zip}
                                                    </p>
                                                  );
                                                })}
                                              </Col>
                                              <Col md="6">
                                                <p>
                                                  <b>AGE:</b>{" "}
                                                  {person?.age || "-"}
                                                </p>
                                              </Col>
                                              <Col md="6">
                                                {" "}
                                                <p>
                                                  <b>Gender:</b>{" "}
                                                  {person?.gender || "-"}
                                                </p>
                                              </Col>
                                              <Col md="12">
                                                <p>
                                                  <b>Birth:</b>{" "}
                                                  {person?.dob || "-"}
                                                </p>
                                                <p>
                                                  <b>Death:</b>{" "}
                                                  {person?.dod || "-"}
                                                </p>
                                              </Col>
                                            </Row>
                                          </Col>
                                          <Col md="7">
                                            <Row>
                                              <Col xs="10" md="9">
                                                <h5 className="fw-bold">
                                                  Phone Numbers
                                                </h5>{" "}
                                              </Col>
                                              <Col xs="2" md="3"></Col>
                                            </Row>
                                            <Row className="g-0">
                                              {person?.phones?.map((ph, k) => (
                                                <Col
                                                  xs="6"
                                                  className="mb-1"
                                                  key={k}
                                                >
                                                  {ph.phone}
                                                  <Button
                                                    className="border-0 btn-transition"
                                                    outline
                                                    color="success"
                                                    onClick={() =>
                                                      (window.location.href = `tel:${ph?.phone}`)
                                                    }
                                                  >
                                                    <FontAwesomeIcon
                                                      icon={faPhone}
                                                      size="1x"
                                                    />
                                                  </Button>
                                                </Col>
                                              ))}
                                            </Row>

                                            <Row>
                                              <Col xs="10">
                                                <h5 className="fw-bold mt-3">
                                                  Emails{" "}
                                                </h5>
                                              </Col>
                                              <Col xs="2"></Col>
                                            </Row>

                                            {person?.emails?.map((e, k) => (
                                              <Row className="g-0" key={k}>
                                                <Col xs="10" className="mb-1">
                                                  {e?.email}
                                                </Col>
                                                <Col xs="2">
                                                  <Button
                                                    className="border-0 btn-transition"
                                                    outline
                                                    color="info"
                                                    title=" Mail"
                                                    onClick={() =>
                                                      window.open(`mailto:${e?.email}`)
                                                    }
                                                  >
                                                    <FontAwesomeIcon
                                                      icon={faEnvelope}
                                                      size="1x"
                                                    />
                                                  </Button>
                                                </Col>
                                              </Row>
                                            ))}
                                          </Col>
                                        </Row>
                                      </CardBody>
                                    </Card>
                                  );
                                })}
                          </Col>
                        </Row>
                        
                        {(data?.lead_info?.frst?.people &&
                              Object.keys(data?.lead_info?.frst?.people)
                                .filter(
                                  (key) =>
                                    data?.lead_info?.frst?.people[key]
                                      ?.title === "Relatives"
                                ).length > 0) &&
                        <Row>
                          <Col md="12">
                            <Card className="main-card mb-1">
                              <CardBody>
                                <CardTitle>Relatives</CardTitle>
                                <Row>


                                {data?.lead_info?.frst?.people &&
                              Object.keys(data?.lead_info?.frst?.people)
                                .filter(
                                  (key) =>
                                    data?.lead_info?.frst?.people[key]
                                      ?.title === "Relatives"
                                )
                                .map((key, index) => {
                                  const person =
                                    data?.lead_info?.frst?.people[key];
                                  // Render JSX for each person with title "Relatives"
                                  return (
                                    <Card className="main-card mb-1">
                                      <CardBody>
                                        <CardTitle></CardTitle>

                                        <Row>
                                          <Col md="5" className="text-center">
                                            <Row className="g-0">
                                              <Col md="12">
                                                <h4 className="text-primary m-0 text-center">
                                                  {person?.title}
                                                </h4>
                                              </Col>
                                              <Col md="12">
                                                <h3
                                                  style={{ color: "#003333" }}
                                                >
                                                  {person?.full_name || " "}{" "}
                                                </h3>
                                              </Col>
                                              <Col md="12">
                                                {Object.keys(
                                                  person?.addresses
                                                ).map((k, index) => {
                                                  const address =
                                                    person?.addresses[key];
                                                  // Render JSX for each person with title "Relatives"
                                                  return (
                                                    <p>
                                                      {address?.address1 || ""}
                                                      <br /> {address?.city},{" "}
                                                      {address?.state}{" "}
                                                      {address?.zip}
                                                    </p>
                                                  );
                                                })}
                                              </Col>
                                              <Col md="6">
                                                <p>
                                                  <b>AGE:</b>{" "}
                                                  {person?.age || "-"}
                                                </p>
                                              </Col>
                                              <Col md="6">
                                                {" "}
                                                <p>
                                                  <b>Gender:</b>{" "}
                                                  {person?.gender || "-"}
                                                </p>
                                              </Col>
                                              <Col md="12">
                                                <p>
                                                  <b>Birth:</b>{" "}
                                                  {person?.dob || "-"}
                                                </p>
                                                <p>
                                                  <b>Death:</b>{" "}
                                                  {person?.dod || "-"}
                                                </p>
                                              </Col>
                                            </Row>
                                          </Col>
                                          <Col md="7">
                                            <Row>
                                              <Col xs="10" md="9">
                                                <h5 className="fw-bold">
                                                  Phone Numbers
                                                </h5>{" "}
                                              </Col>
                                              <Col xs="2" md="3"></Col>
                                            </Row>
                                            <Row className="g-0">
                                              {person?.phones && person?.phones?.map((ph, k) => (
                                                <Col
                                                  xs="6"
                                                  className="mb-1"
                                                  key={k}
                                                >
                                                  {ph.phone}
                                                  <Button
                                                    className="border-0 btn-transition"
                                                    outline
                                                    color="success"
                                                    onClick={() =>
                                                      (window.location.href = `tel:${ph?.phone}`)
                                                    }
                                                  >
                                                    <FontAwesomeIcon
                                                      icon={faPhone}
                                                      size="1x"
                                                    />
                                                  </Button>
                                                </Col>
                                              ))}
                                            </Row>

                                            <Row>
                                              <Col xs="10">
                                                <h5 className="fw-bold mt-3">
                                                  Emails{" "}
                                                </h5>
                                              </Col>
                                              <Col xs="2"></Col>
                                            </Row>

                                            {person?.emails && person?.emails?.map((e, k) => (
                                              <Row className="g-0" key={k}>
                                                <Col xs="10" className="mb-1">
                                                  {e?.email}
                                                </Col>
                                                <Col xs="2">
                                                  <Button
                                                    className="border-0 btn-transition"
                                                    outline
                                                    color="info"
                                                    title=" Mail"
                                                    onClick={() =>
                                                      window.open(`mailto:${e?.email}`)
                                                    }
                                                  >
                                                    <FontAwesomeIcon
                                                      icon={faEnvelope}
                                                      size="1x"
                                                    />
                                                  </Button>
                                                </Col>
                                              </Row>
                                            ))}
                                          </Col>
                                        </Row>
                                      </CardBody>
                                    </Card>
                                  );
                                })}




                                  {/* {data?.lead_info?.firstup?.relatives?.map(
                                    (v, k) => (
                                      <Col md="12" className="mb-2" key={k}>
                                        <Card className="main-card">
                                          <CardBody>
                                            <CardTitle></CardTitle>

                                            <Row>
                                              <Col
                                                md="5"
                                                className="text-center"
                                              >
                                                <Row className="g-0">
                                                  <Col md="12">
                                                    <h4 className="text-primary m-0 text-center">
                                                      Relative
                                                    </h4>
                                                  </Col>
                                                  <Col md=" 12">
                                                    {" "}
                                                    <h3>
                                                      {v.first_name}{" "}
                                                      {v.middle_name}{" "}
                                                      {v.last_name}{" "}
                                                    </h3>
                                                  </Col>
                                                  <Col md=" 12">
                                                    <Row className="g-0">
                                                      {v.addresses?.map(
                                                        (address, k) => (
                                                          <Col md="12" key={k}>
                                                            <b>ADDRESS:</b>{" "}
                                                            {address.address1},{" "}
                                                            {address.city},{" "}
                                                            {address.state}{" "}
                                                            {address.zip}
                                                          </Col>
                                                        )
                                                      )}
                                                    </Row>
                                                  </Col>
                                                  <Col md="6">
                                                    <p>
                                                      <b>AGE:</b> {v.age || "-"}
                                                    </p>
                                                  </Col>
                                                  <Col md="6">
                                                    <p>
                                                      <b>Gender:</b>{" "}
                                                      {v.gender || "-"}
                                                    </p>
                                                  </Col>
                                                </Row>
                                              </Col>
                                              <Col md="7">
                                                <Row>
                                                  <Col xs="10" md="9">
                                                    <h5 className="fw-bold">
                                                      Phone Numbers
                                                    </h5>{" "}
                                                  </Col>
                                                  <Col xs="2" md="3"></Col>
                                                </Row>
                                                <Row className="g-0">
                                                  {v?.phones?.map((ph, k) => (
                                                    <Col
                                                      xs="12"
                                                      className="mb-1"
                                                      key={k}
                                                    >
                                                      {ph.phone}
                                                      <Button
                                                        className="border-0 btn-transition"
                                                        outline
                                                        color="success"
                                                        onClick={() =>
                                                          (window.location.href = `tel:${ph?.phone}`)
                                                        }
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={faPhone}
                                                          size="1x"
                                                        />
                                                      </Button>
                                                    </Col>
                                                  ))}
                                                </Row>

                                                <Row>
                                                  <Col xs="10">
                                                    <h5 className="fw-bold mt-3">
                                                      Emails{" "}
                                                    </h5>
                                                  </Col>
                                                  <Col xs="2"></Col>
                                                </Row>

                                                {v?.emails?.map((e, k) => (
                                                  <Row className="g-0">
                                                    <Col
                                                      xs="10"
                                                      className="mb-1"
                                                      key={k}
                                                    >
                                                      {e}
                                                    </Col>
                                                    <Col xs="2">
                                                      <Button
                                                        className="border-0 btn-transition"
                                                        outline
                                                        color="info"
                                                        title=" Mail"
                                                        onClick={() =>
                                                          window.open(
                                                            `mailto:${e}`
                                                          )
                                                        }
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={faEnvelope}
                                                          size="1x"
                                                        />
                                                      </Button>
                                                    </Col>
                                                  </Row>
                                                ))}
                                              </Col>
                                            </Row>
                                          </CardBody>
                                        </Card>
                                      </Col>
                                    )
                                  )} */}
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>}
                      </Collapse>
                    </CardBody>
                  </Card>
                </Col>
              )}
              {data?.lead_info?.prb && (
                <Col md="12">
                  <Card className="main-card mb-2">
                    <CardBody>
                      <CardTitle>
                        <Row>
                          <Col xs="10">
                            <legend>Probate</legend>
                          </Col>
                          <Col xs="2">
                            <Button
                              className="m-0 p-0"
                              color="link"
                              onClick={() => setCustom2(!custom2)}
                            >
                              {custom2 === false ? "Expand" : "Collapse"}
                            </Button>
                          </Col>
                        </Row>
                      </CardTitle>

                      <Collapse isOpen={custom2}>
                        <Row>
                          <Col md="12">
                            <Card className="main-card mb-1">
                              <CardBody>
                                <Row className="g-1">
                                  <Col md="4">
                                    <div className="card widget-chart p-0">
                                      <div className="widget-numbers">
                                        Probate
                                      </div>
                                      <div className="widget-subheading">
                                        Lead Type
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md="4">
                                    <div className="card widget-chart p-0">
                                      <div className="widget-numbers">
                                        {data?.lead_info?.prb?.probate_id ||
                                          "-"}
                                      </div>
                                      <div className="widget-subheading">
                                        Case ID
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md="4">
                                    <div className="card  widget-chart p-0">
                                      <div className="widget-numbers">
                                        {data?.lead_info?.prb?.p_month ||
                                          "-"}{" "}
                                        /{" "}
                                        {data?.lead_info?.prb?.p_day || "-"}{" "}
                                        /{" "}
                                        {data?.lead_info?.prb?.p_year ||
                                          "-"}
                                      </div>
                                      <div className="widget-subheading">
                                        Lead Date
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            {data?.lead_info?.prb?.people &&
                              Object.keys(data?.lead_info?.prb?.people)
                                .filter(
                                  (key) =>
                                    data?.lead_info?.prb?.people[key]
                                      ?.title !== "Relatives"
                                )
                                .map((key, index) => {
                                  const person =
                                    data?.lead_info?.prb?.people[key];
                                  return (
                                    <Card key={index} className="main-card mb-1">
                                      <CardBody>
                                        <CardTitle></CardTitle>

                                        <Row>
                                          <Col md="5" className="text-center">
                                            <Row className="g-0">
                                              <Col md="12">
                                                <h4 className="text-primary m-0 text-center">
                                                  {person?.title}
                                                </h4>
                                              </Col>
                                              <Col md="12">
                                                <h3
                                                  style={{ color: "#003333" }}
                                                >
                                                  {person?.full_name || " "}{" "}
                                                </h3>
                                              </Col>
                                              <Col md="12">
                                                {Object.keys(
                                                  person?.addresses
                                                ).map((k, index) => {
                                                  const address =
                                                    person?.addresses[key];
                                                  return (
                                                    <p key={index}>
                                                      {address?.address1 || ""}
                                                      <br /> {address?.city},{" "}
                                                      {address?.state}{" "}
                                                      {address?.zip}
                                                    </p>
                                                  );
                                                })}
                                              </Col>
                                              <Col md="6">
                                                <p>
                                                  <b>AGE:</b>{" "}
                                                  {person?.age || "-"}
                                                </p>
                                              </Col>
                                              <Col md="6">
                                                {" "}
                                                <p>
                                                  <b>Gender:</b>{" "}
                                                  {person?.gender || "-"}
                                                </p>
                                              </Col>
                                              <Col md="12">
                                                <p>
                                                  <b>Birth:</b>{" "}
                                                  {person?.dob || "-"}
                                                </p>
                                                <p>
                                                  <b>Death:</b>{" "}
                                                  {person?.dod || "-"}
                                                </p>
                                              </Col>
                                            </Row>
                                          </Col>
                                          <Col md="7">
                                            <Row>
                                              <Col xs="10" md="9">
                                                <h5 className="fw-bold">
                                                  Phone Numbers
                                                </h5>{" "}
                                              </Col>
                                              <Col xs="2" md="3"></Col>
                                            </Row>
                                            <Row className="g-0">
                                              {person?.phones?.map((ph, k) => (
                                                <Col
                                                  xs="6"
                                                  className="mb-1"
                                                  key={k}
                                                >
                                                  {ph.phone}
                                                  <Button
                                                    className="border-0 btn-transition"
                                                    outline
                                                    color="success"
                                                    onClick={() =>
                                                      (window.location.href = `tel:${ph?.phone}`)
                                                    }
                                                  >
                                                    <FontAwesomeIcon
                                                      icon={faPhone}
                                                      size="1x"
                                                    />
                                                  </Button>
                                                </Col>
                                              ))}
                                            </Row>

                                            <Row>
                                              <Col xs="10">
                                                <h5 className="fw-bold mt-3">
                                                  Emails{" "}
                                                </h5>
                                              </Col>
                                              <Col xs="2"></Col>
                                            </Row>

                                            {person?.emails?.map((e, k) => (
                                              <Row className="g-0" key={k}>
                                                <Col xs="10" className="mb-1">
                                                  {e?.email}
                                                </Col>
                                                <Col xs="2">
                                                  <Button
                                                    className="border-0 btn-transition"
                                                    outline
                                                    color="info"
                                                    title=" Mail"
                                                    onClick={() =>
                                                      window.open(`mailto:${e?.email}`)
                                                    }
                                                  >
                                                    <FontAwesomeIcon
                                                      icon={faEnvelope}
                                                      size="1x"
                                                    />
                                                  </Button>
                                                </Col>
                                              </Row>
                                            ))}
                                          </Col>
                                        </Row>
                                      </CardBody>
                                    </Card>
                                  );
                                })}
                          </Col>
                        </Row>

                        {(data?.lead_info?.prb?.people &&
                              Object.keys(data?.lead_info?.prb?.people)
                                .filter(
                                  (key) =>
                                    data?.lead_info?.prb?.people[key]
                                      ?.title === "Relatives"
                                ).length > 0) &&
                        <Row>
                          <Col md="12">
                            <Card className="main-card mb-1">
                              <CardBody>
                                <CardTitle>Relatives</CardTitle>
                                <Row>


                                {data?.lead_info?.prb?.people &&
                              Object.keys(data?.lead_info?.prb?.people)
                                .filter(
                                  (key) =>
                                    data?.lead_info?.prb?.people[key]
                                      ?.title === "Relatives"
                                )
                                .map((key, index) => {
                                  const person =
                                    data?.lead_info?.prb?.people[key];
                                  // Render JSX for each person with title "Relatives"
                                  return (
                                    <Card className="main-card mb-1">
                                      <CardBody>
                                        <CardTitle></CardTitle>

                                        <Row>
                                          <Col md="5" className="text-center">
                                            <Row className="g-0">
                                              <Col md="12">
                                                <h4 className="text-primary m-0 text-center">
                                                  {person?.title}
                                                </h4>
                                              </Col>
                                              <Col md="12">
                                                <h3
                                                  style={{ color: "#003333" }}
                                                >
                                                  {person?.full_name || " "}{" "}
                                                </h3>
                                              </Col>
                                              <Col md="12">
                                                {Object.keys(
                                                  person?.addresses
                                                ).map((k, index) => {
                                                  const address =
                                                    person?.addresses[key];
                                                  // Render JSX for each person with title "Relatives"
                                                  return (
                                                    <p>
                                                      {address?.address1 || ""}
                                                      <br /> {address?.city},{" "}
                                                      {address?.state}{" "}
                                                      {address?.zip}
                                                    </p>
                                                  );
                                                })}
                                              </Col>
                                              <Col md="6">
                                                <p>
                                                  <b>AGE:</b>{" "}
                                                  {person?.age || "-"}
                                                </p>
                                              </Col>
                                              <Col md="6">
                                                {" "}
                                                <p>
                                                  <b>Gender:</b>{" "}
                                                  {person?.gender || "-"}
                                                </p>
                                              </Col>
                                              <Col md="12">
                                                <p>
                                                  <b>Birth:</b>{" "}
                                                  {person?.dob || "-"}
                                                </p>
                                                <p>
                                                  <b>Death:</b>{" "}
                                                  {person?.dod || "-"}
                                                </p>
                                              </Col>
                                            </Row>
                                          </Col>
                                          <Col md="7">
                                            <Row>
                                              <Col xs="10" md="9">
                                                <h5 className="fw-bold">
                                                  Phone Numbers
                                                </h5>{" "}
                                              </Col>
                                              <Col xs="2" md="3"></Col>
                                            </Row>
                                            <Row className="g-0">
                                              {person?.phones && person?.phones?.map((ph, k) => (
                                                <Col
                                                  xs="6"
                                                  className="mb-1"
                                                  key={k}
                                                >
                                                  {ph.phone}
                                                  <Button
                                                    className="border-0 btn-transition"
                                                    outline
                                                    color="success"
                                                    onClick={() =>
                                                      (window.location.href = `tel:${ph?.phone}`)
                                                    }
                                                  >
                                                    <FontAwesomeIcon
                                                      icon={faPhone}
                                                      size="1x"
                                                    />
                                                  </Button>
                                                </Col>
                                              ))}
                                            </Row>

                                            <Row>
                                              <Col xs="10">
                                                <h5 className="fw-bold mt-3">
                                                  Emails{" "}
                                                </h5>
                                              </Col>
                                              <Col xs="2"></Col>
                                            </Row>

                                            {person?.emails && person?.emails?.map((e, k) => (
                                              <Row className="g-0" key={k}>
                                                <Col xs="10" className="mb-1">
                                                  {e?.email}
                                                </Col>
                                                <Col xs="2">
                                                  <Button
                                                    className="border-0 btn-transition"
                                                    outline
                                                    color="info"
                                                    title=" Mail"
                                                    onClick={() =>
                                                      window.open(`mailto:${e?.email}`)
                                                    }
                                                  >
                                                    <FontAwesomeIcon
                                                      icon={faEnvelope}
                                                      size="1x"
                                                    />
                                                  </Button>
                                                </Col>
                                              </Row>
                                            ))}
                                          </Col>
                                        </Row>
                                      </CardBody>
                                    </Card>
                                  );
                                })}
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>}
                      </Collapse>
                    </CardBody>
                  </Card>
                </Col>
              )}
            </Row>
          </div>
        </CSSTransition>
      </TransitionGroup>
    </Fragment>
  );
}
